import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ExamDocumentType } from "./enums/document-type.enum";
import { Exam } from "./interfaces/exam.interface";

@Injectable({
    providedIn: "root"
})
export class CurrentExamService {
    private examMetadata$: BehaviorSubject<Exam | undefined> = new BehaviorSubject(undefined);
    private initialDocument$: BehaviorSubject<File | undefined> = new BehaviorSubject(undefined);
    private inProgress$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private draftTabIds$: BehaviorSubject<string[]> = new BehaviorSubject([]);
    private examTabId$: BehaviorSubject<string | undefined> = new BehaviorSubject(undefined);

    get examMetadata(): Exam | undefined {
        return this.examMetadata$.getValue();
    }

    get examMetadataObservable(): Observable<Exam | undefined> {
        return this.examMetadata$.asObservable();
    }

    get initialDocument(): File | undefined {
        return this.initialDocument$.getValue();
    }

    get inProgress(): boolean {
        return this.inProgress$.getValue();
    }

    get inProgressObservable(): Observable<boolean> {
        return this.inProgress$.asObservable();
    }

    get draftTabIds(): string[] {
        return this.draftTabIds$.getValue();
    }

    get draftTabIdsObservable(): Observable<string[]> {
        return this.draftTabIds$.asObservable();
    }

    get examTabId(): string {
        return this.examTabId$.getValue() || '';
    }

    constructor() { }

    public getDocDocumentType(docId: string): ExamDocumentType | null {
        if (this.isExamDoc(docId)) {
            return ExamDocumentType.Exam;
        }

        if (this.isDraftDoc(docId)) {
            return ExamDocumentType.Draft;
        }

        return null;
    }

    public setExamMetadata(exam: Exam): void {
        this.examMetadata$.next(exam);
    }

    public setExamInitialDocument(file: File): void {
        this.initialDocument$.next(file);
    }

    public setInProgress(value: boolean): void {
        if(this?.inProgress$)
        this.inProgress$.next(value);
    }

    public addDraftTabId(value: string): void {
        this.draftTabIds$.next([...this.draftTabIds, value]);
    }

    public setDraftTabIds(value: string[]): void {
        this.draftTabIds$.next(value);
    }

    public setExamTabId(value: string): void {
        this.examTabId$.next(value);
    }

    public clear() {
        this.inProgress$.next(false);
        this.examMetadata$.next(undefined);
        this.initialDocument$.next(undefined);
        this.examTabId$.next(undefined);
        this.draftTabIds$.next([]);
    }

    private isExamDoc(docId: string) {
        return docId === this.examTabId;
    }

    private isDraftDoc(docId: string) {
        return this.draftTabIds.includes(docId);
    }
}